import { AMBIENT_SCRIBE_STATUS_PAUSED } from "features/medical-scribe/medical-scribe-constants";

/** Max wait for context auto-save flush before Resume proceeds (SN-17727). */
export const CONTEXT_SAVE_FLUSH_TIMEOUT_MS = 5000;

export type ResumePleaseWaitInput = {
  isResuming: boolean;
};

/**
 * Resume button shows "Please wait" only during an active user-initiated resume.
 * Background cleanup and widget SAVING are handled inside the resume flow with
 * bounded waits — they must not disable the button preemptively.
 */
export function computeIsResumePleaseWait({
  isResuming
}: ResumePleaseWaitInput): boolean {
  return isResuming;
}

/** Poll until status leaves Paused after POST /complete/ (SN-17727). */
export function shouldClearAwaitingCompletion(
  freshStatus: number | undefined,
  wasCancelled: boolean
): boolean {
  if (wasCancelled) return true;
  return (
    freshStatus != null &&
    freshStatus !== AMBIENT_SCRIBE_STATUS_PAUSED
  );
}

export const AWAITING_COMPLETION_POLL_MS = 2000;
export const AWAITING_COMPLETION_TIMEOUT_MS = 90_000;
